import type { ColumnConfig } from "../../SpreadsheetEditor";
import type { ScopeItemRowDraft } from "../ScopeItemRowsEditor";

export interface DraftSnapshot {
	name: string;
	description: string;
	quoteTableName: string;
	columns: ColumnConfig[];
	rows: ScopeItemRowDraft[];
}

export const BLANK_TEMPLATE_VALUE = "__blank__";

export const generateLocalRowId = (): number =>
	-Math.floor(Math.random() * 1_000_000_000);
